import {
  PagePermission,
  TabPermission,
} from 'src/app/core/interfaces/permissions';
import { DataRewards } from '../../data-rewards.setup';

import { DataRewardsDatabackTab, DataRewardsDataOffersTab } from './tabs';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';

const parent = DataRewards.pages.offersDatabackManagement;
const title = 'PAGE.DATA_REWARDS.OFFERS_DATABACK_MANAGEMENT.TITLE';
const tabs: TabPermission[] = [
  DataRewardsDataOffersTab,
  DataRewardsDatabackTab,
];

export const OffersDatabackManagementPage: PagePermission =
  PermissionsC.generatePagePermission(parent, title, tabs);
